import { searchObjectsByAttribute } from '../utils/index'
import { paginate } from '../utils/index'
import { Response } from 'miragejs'

export function partnerRoutes() {
  const restPrefix = process.env.MOCK_REST_URL_SUFIX
  this.urlPrefix = process.env.MOCK_BASE_APIS_URL
  this.get(`${restPrefix}/partners/engagement/`, (schema, request) => {
    const route_path = `${this.urlPrefix}/partners/engagement/`
    const { queryParams: { page = 1, limit = 5, slug } } = request

    let partners = schema.db.partners

    partners = slug ? searchObjectsByAttribute(partners, 'slug', slug) : partners || []
    const { paginatedItems, meta } = paginate(
      partners,
      parseInt(page),
      parseInt(limit)
    )
    return new Response(200, {},{
      data: paginatedItems,
      links: {
        first: `${route_path}?page=1`,
        last: `${route_path}?page=2`,
        prev: null,
        next: null
      },
      meta,
    })
  })
  this.get(`${restPrefix}/partners/engagement?slug=:slug`, (schema, request) => {
    const partners = schema.db.partners
    return partners[0]
  })
}



// WEBPACK FOOTER //
// ./src/mocks/routes/partners.js